<template>
  <div class="container" v-if="item">
    <h1>
      {{ item.title }}
      <router-link class="btn btn-primary btn-sm pull-right" :to="`/pages/${item._id}/edit`" v-if="isAdmin">
        Edit
      </router-link>
    </h1>
    <hr>
    <div class="row">
      <div class="col">
        <div v-if="item && item.body">
          <div v-html="$embers.markdownIt(item.body)"></div>
        </div>
      </div>
    </div>
    <div class="row hidden-print return-to-list">
      <div class="col text-center">
        <router-link to="/pages"><i class="fa fa-angle-double-left"></i> Return to list</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "page-show",
  watch: {
    // call again the method if the route changes
    $route: "getData"
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    ...mapState({
      user: state => state.session.user,
      item: state => state.pages.current
    })
  },
  methods: {
    ...mapActions({
      pagesRead: "pages/read"
    }),
    async getData() {
      try {
        await this.pagesRead({ id: this.$route.params.id });
        this.$embers.pageData(
          this.item.title,
          this.item.description,
          this.item.keywords
        );
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>
